export default __webpack_public_path__ + "static/media/storeCsv.b32f77cf.csv";